import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { UtilsService } from 'src/app/shared/utils.service';

@Component({
    selector: 'app-add-edit-department',
    templateUrl: './add-edit-department.component.html',
    styleUrls: ['./add-edit-department.component.scss'],
    standalone: false
})
export class AddEditDepartmentComponent implements OnInit {
  addDepartmentForm: FormGroup;
  type: string;
  id: number;
  name: string;

  constructor(public dialogRef: MatDialogRef<AddEditDepartmentComponent>,
              private dataService: DataService,
              public utils: UtilsService,
              private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) {
                this.type = data.type;
                this.id = data.id;
                this.name = data.name;
               }

  ngOnInit(): void {
    this.addDepartmentForm = new FormGroup({
      department_name: new FormControl(this.name, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
    });
  }

  closeDialog() {
    if (this.addDepartmentForm.dirty && this.type === 'Add') {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Warning',
          type: 'Warn',
          message: 'You will miss your information once you close',
          buttonText: 'cancel',
          numberOfButtons: 2,
          seconButtonText: 'Ok'
        }
      });
      dialogRef.afterClosed().subscribe((status) => {
        if (status === 'Ok') {
          this.dialog.closeAll();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

  onSubmit() {
    if (this.addDepartmentForm.valid) {
      if (this.type === 'Edit') {
        const payload = {
          id: this.id,
          name: this.addDepartmentForm.get('department_name').value,
        };
        this.dataService.put('department/UpdateDepartment', payload).then((data) => {
          if (data.statusCode === 200) {
            this.dialogRef.close({id: this.id, name: this.addDepartmentForm.get('department_name').value});
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Success',
                type: 'Success',
                message: 'Department updated successfully',
                buttonText: 'Ok'
              }
            });
          } else if (data.statusCode === 600){
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'The name of this department is already used. Please enter a new name!',
                buttonText: 'Ok'
              }
            });
          } else {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Something went wrong, Please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
      } else if (this.type === 'Add') {
        const payload = {
          name: this.addDepartmentForm.get('department_name').value,
        };
        this.dataService.post('department/CreateDepartment', payload).then((data) => {
          if (data.statusCode === 200) {
            this.dialogRef.close({id: data.data.id, name: data.data.name});
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Success',
                type: 'Success',
                message: 'Department added successfully',
                buttonText: 'Ok'
              }
            });
          } else if (data.statusCode === 600){
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'The name of this department is already used. Please enter a new name!',
                buttonText: 'Ok'
              }
            });
          } else {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Something went wrong, Please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
      }
    }
  }
}
